import createIcon from '../../createIcon';

/**
 * @component @name Inbox
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g0Ljk5QzMuODggMyAzLjAxIDMuODkgMy4wMSA1TDMgMTlDMyAyMC4xIDMuODggMjEgNC45OSAyMUgxOUMyMC4xIDIxIDIxIDIwLjEgMjEgMTlWNUMyMSAzLjg5IDIwLjEgMyAxOSAzWk0xOSAxNUgxNUMxNSAxNi42NiAxMy42NSAxOCAxMiAxOEMxMC4zNSAxOCA5IDE2LjY2IDkgMTVINC45OVY1SDE5VjE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Inbox = createIcon('Inbox', [
  [
    'path',
    {
      d: 'M19 3H4.99C3.88 3 3.01 3.89 3.01 5L3 19C3 20.1 3.88 21 4.99 21H19C20.1 21 21 20.1 21 19V5C21 3.89 20.1 3 19 3ZM19 15H15C15 16.66 13.65 18 12 18C10.35 18 9 16.66 9 15H4.99V5H19V15Z',
      key: '1slob5',
    },
  ],
]);

export default Inbox;
